import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAdAccount } from "../lib/adAccount";
import { Warning, Lightning } from "@phosphor-icons/react";

const SEVERITY = {
  ok: { color: "border-emerald-500/30 bg-emerald-500/5 text-emerald-400", icon: Lightning, label: "OK" },
  warning: { color: "border-amber-500/40 bg-amber-500/10 text-amber-400", icon: Warning, label: "Warning" },
  critical: { color: "border-orange-500/50 bg-orange-500/10 text-orange-400", icon: Warning, label: "Critical" },
  urgent: { color: "border-red-500/60 bg-red-500/15 text-red-400", icon: Warning, label: "Urgent" },
};

const fmtMoney = (n) => "RM" + (n || 0).toLocaleString("en-MY", { maximumFractionDigits: 2 });

export default function BillingBanner() {
  const { selected } = useAdAccount();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!selected) return;
    api.get(`/billing/status?ad_account_id=${selected}`).then(r => setData(r.data)).catch(() => setData(null));
  }, [selected]);

  if (!data || !data.configured || data.severity === "ok") return null;
  const cfg = SEVERITY[data.severity];
  const Icon = cfg.icon;

  return (
    <div data-testid="billing-banner" className={`border ${cfg.color} px-4 py-2.5 mb-4 flex items-center gap-3`}>
      <Icon size={16} weight="fill" className="shrink-0" />
      <div className="flex-1 text-xs">
        <span className="font-mono uppercase tracking-wider text-[10px] mr-2">[{cfg.label}]</span>
        <span className="font-medium">{fmtMoney(data.remaining)} remaining</span>
        <span className="text-zinc-500"> · {data.pct_remaining}% of {fmtMoney(data.credit_limit)} budget · cycle ends {data.cycle_end}</span>
      </div>
      <div className="w-32 h-1 bg-zinc-800 relative overflow-hidden">
        <div
          className={`h-full transition-all ${data.severity === "urgent" ? "bg-red-500" : data.severity === "critical" ? "bg-orange-500" : "bg-amber-500"}`}
          style={{ width: `${100 - data.pct_remaining}%` }}
        />
      </div>
    </div>
  );
}
